import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '../../environments/environment';
import { IResident, IResidentDetails } from '../models/HealthMinistry';

/**
 * Health ministry service
 */
@Injectable({ providedIn: "root" })
export class HealthMinistryService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/healthMinistry` }

    getResidents(): Observable<IResident[]> {
        const url = `${this.apiUrl}/residents`;
        return this.http.get<IResident[]>(url);
    }

    getResident(id: string): Observable<IResidentDetails> {
        const url = `${this.apiUrl}/residents/${id}`;
        return this.http.get<IResidentDetails>(url);
    }
}
